<template>
  <div :class="{ 'html-mode': !!html }">
    <span v-if="!html" ref="text" :class="[textClass, { 'text-clamp': !expanded }]" v-text="text"></span>
    <div v-else ref="text" :class="[textClass, { 'text-clamp-html': !expanded }]" v-html="html"></div>
    <span v-if="needsExpander" class="show-more-link" @click.stop="expanded = !expanded">
      {{ expanded ? 'Show less ▴' : 'Show more ▾' }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'TextClamp',
  props: {
    text: { type: String, default: '' },
    html: { type: String, default: '' },
    textClass: { type: String, default: '' },
  },
  data() {
    return {
      expanded: false,
      needsExpander: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      const el = this.$refs.text;
      if (!el) return;
      this.checkExpander(el);
      if (window.ResizeObserver) {
        this._ro = new ResizeObserver(() => this.checkExpander(el));
        this._ro.observe(el);
      }
    });
  },

  beforeDestroy() {
    this._ro?.disconnect();
  },
  methods: {
    checkExpander(el = this.$refs.text) {
      if (!el || !el.clientHeight) return;
      this.needsExpander = el.scrollHeight > el.clientHeight || this.expanded;
    },
    resetExpander() {
      this.expanded = false;
      this.$nextTick(() => this.checkExpander());
    }
  },

  watch: {
    text: "resetExpander",
    html: "resetExpander"
  }
};
</script>

<style scoped>
.show-more-link {
  display: none;
}

/* Desktop: HTML content — clamp at 7 lines */
.text-clamp-html {
  max-height: 10.5em;
  overflow: hidden;
}

.html-mode .show-more-link {
  display: inline;
  font-size: 0.78rem;
  color: #b8963e;
  cursor: pointer;
  margin-top: 4px;
  user-select: none;
}

.html-mode .show-more-link:hover {
  color: #d6b674;
  text-decoration: underline;
}

/* Mobile: plain text clamp at 3 lines, HTML clamp at 3 lines */
@media (max-width: 576px) {
  .text-clamp {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
  }

  .text-clamp-html {
    max-height: 4.5em;
  }

  .show-more-link {
    display: inline;
    font-size: 0.78rem;
    color: #b8963e;
    cursor: pointer;
    margin-top: 4px;
    user-select: none;
  }

  .show-more-link:hover {
    color: #d6b674;
    text-decoration: underline;
  }
}
</style>